
import { ValidationRule, ValidationType } from 'app/infrastructure/simple-form';
import { sfNames } from 'app/area/administration/edit/sf-names';
import { AlternativeIdItemData } from 'app/area/administration/edit/user/alternative-id/types';
import { alternativeIdFieldName } from './constants';

export const getValidationProps = (fieldId: string, validateFields: number[], data: AlternativeIdItemData) => {

  const validationMap: Record<string, any[]> = {
    [sfNames.personId]: [
      { type: ValidationType.Required },
      {
        type: ValidationType.Unique,
        fields: validateFields
          ?.filter(id => id !== data.id)
          ?.map(id => alternativeIdFieldName(sfNames.personId, id)),
        rules: [ValidationRule.IgnoreCaseSensitivity]
      }
    ],
    [sfNames.name]: [
      { type: ValidationType.Required },
      {
        type: ValidationType.Unique,
        fields: validateFields
          ?.filter(id => id !== data.id)
          ?.map(id => alternativeIdFieldName(sfNames.name, id)),
        rules: [ValidationRule.IgnoreCaseSensitivity]
      }]
  };

  return validationMap[fieldId] || [];
};  
